/* eslint-disable react/display-name */
import React, { type ForwardedRef } from 'react';

import { PageTitle } from '@dec/shared';
import { BodyPreview } from 'app/modules/Reports/Preview/body';
import { GeneralPreview } from 'app/modules/Reports/Preview/general';
import { HeaderPreview } from 'app/modules/Reports/Preview/header';
import { type TaxReturn } from 'app/modules/Reports/TaxReturnList/types';
import { t } from 'i18next';
import { FileEarmarkText } from 'react-bootstrap-icons';

export const PageToPrint = React.forwardRef(
  ({ taxreturn }: { taxreturn: TaxReturn }, ref: ForwardedRef<HTMLDivElement>) => {
    return (
      <div className="print-only" ref={ref}>
        <div className="d-print-none">
          <PageTitle
            title={t('config.taxReturn')}
            subtitle={t('taxreturn-report.title.page')}
            icon={FileEarmarkText}
          />
        </div>
        <HeaderPreview />
        <GeneralPreview taxreturn={taxreturn} />

        <BodyPreview taxreturn={taxreturn} />
      </div>
    );
  }
);
